import axios from 'axios';
import { getHomeboxServiceUrl } from '../utils/urlConfig';

/**
 * Creates a custom Axios instance with dynamic base URL resolution.
 * Supports LAN IP, custom ports, localhost, and production domains.
 */
const axiosInstance = axios.create();

/**
 * Request interceptor to set dynamic baseURL and Authorization header.
 */
axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.baseURL) {
      config.baseURL = getHomeboxServiceUrl();
    }
    const user = localStorage.getItem('user');
    if (user) {
      const token = JSON.parse(user)?.auth_token;
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor to handle API error responses globally.
 */
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        localStorage.removeItem('user');
        window.location.href = '/'; 
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
